import { useUserInfoQuery } from "../hooks/api/useUserInfo";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { changeCustomers } from "../reducer/customersSlice";
import { useNavigate, useLocation } from "react-router-dom";

export default function useCheckLogin() {
    const getUserInfo = useUserInfoQuery();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (getUserInfo.data) {
            // 서버에서 JWT 디코딩된 customers 데이터를 Redux store에 저장
            dispatch(changeCustomers({
                value: getUserInfo.data
            }));

            // 로그인 성공 후 returnPath가 있으면 해당 경로로 복원
            const returnPath = sessionStorage.getItem('returnPath');
            if (returnPath) {
                sessionStorage.removeItem('returnPath');
                // 현재 경로와 다를 때만 이동 (무한 루프 방지)
                if (location.pathname !== returnPath) {
                    navigate(returnPath, { replace: true });
                }
            }
        }

        if (getUserInfo.error) {
            // 인증 실패 시 로그인 페이지로 이동
            // 로그인 완료 후 원래 경로로 복귀하기 위해 현재 경로 저장
            sessionStorage.setItem('returnPath', window.location.pathname);
            window.location.href = process.env.REACT_APP_LOGIN_URL;
        }
    }, [getUserInfo.data, getUserInfo.error]);

    // customers 정보 받아오기 성공하면 화면 노출
    if (getUserInfo.data) {
        return true;
    }
}